export default __webpack_public_path__ + "static/media/orange.e42da835.svg";